import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/Icons/cancel.svg'


const _hoisted_1 = ["title"]
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "img"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "field_file",
    title: _ctx.fileName
  }, [
    (_ctx.isUrl)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.fileName,
          target: "_blank",
          class: "link_file"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.fileName), 1)
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.fileName), 1)),
    _createElementVNode("button", {
      class: "cancel_file",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleteFile', _ctx.fileName)))
    }, _hoisted_5)
  ], 8, _hoisted_1))
}